import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Home, ChevronRight } from "lucide-react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  crumbLabel?: string;
  crumbTo?: string;
  badge?: ReactNode;
  actions?: ReactNode;
}

// In-page header: a two-level breadcrumb (Dashboard › current page), optional subtitle,
// and right-aligned actions. The page name also appears in the top bar.
const PageHeader = ({ title, subtitle, crumbLabel = "Dashboard", crumbTo = "/growlearn", badge, actions }: PageHeaderProps) => (
  <div className="flex flex-wrap items-center justify-between gap-4">
    <div>
      <div className="flex items-center gap-2 text-sm">
        <Link to={crumbTo} className="flex items-center gap-1.5 text-muted-foreground transition-colors hover:text-foreground">
          <Home className="h-4 w-4" /> {crumbLabel}
        </Link>
        <ChevronRight className="h-4 w-4 text-muted-foreground/40" />
        <span className="font-semibold text-foreground">{title}</span>
        {badge}
      </div>
      {subtitle && <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-3">{actions}</div>}
  </div>
);

export default PageHeader;
